import { isListNotEmpty, isNotNullOrUndefined, isNumberGreaterThanOrEqualToZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

class PrescriptionAddOnDetails {
    productId = null;
    variantId = null;
    name = null;
    sku = null;

    medRefId = null; // Beluga med ID
    eRXId = null; // returned rxId
    instructions = null;
    quantity = 1;
    refills = 0;

    providerFirstName = null;
    providerLastName = null;
    providerNPI = null;

    writtenAt = null;
    expirationDate = null;

    constructor(obj) {
        if (isObjectNotEmpty(obj)) {
            if (isStringNotEmpty(obj.productId)) { this.productId = obj.productId; }
            if (isStringNotEmpty(obj.variantId)) { this.variantId = obj.variantId; }
            if (isStringNotEmpty(obj.name)) { this.name = obj.name; }
            if (isStringNotEmpty(obj.sku)) { this.sku = obj.sku; }

            if (isStringNotEmpty(obj.medRefId)) { this.medRefId = obj.medRefId; }
            if (isStringNotEmpty(obj.eRXId)) { this.eRXId = obj.eRXId; }
            if (isStringNotEmpty(obj.instructions)) { this.instructions = obj.instructions; }
            if (isNumberGreaterThanOrEqualToZero(obj.quantity)) { this.quantity = obj.quantity; }
            if (isNumberGreaterThanOrEqualToZero(obj.refills)) { this.refills = obj.refills; }

            if (isStringNotEmpty(obj.providerFirstName)) { this.providerFirstName = obj.providerFirstName; }
            if (isStringNotEmpty(obj.providerLastName)) { this.providerLastName = obj.providerLastName; }
            if (isStringNotEmpty(obj.providerNPI)) { this.providerNPI = obj.providerNPI; }

            if (isNotNullOrUndefined(obj.writtenAt)) { this.writtenAt = obj.writtenAt; }
            if (isNotNullOrUndefined(obj.expirationDate)) { this.expirationDate = obj.expirationDate; }
        }
    }

    toDto = () => ({
        productId: this.productId,
        variantId: this.variantId,
        name: this.name,
        sku: this.sku,

        medRefId: this.medRefId,
        eRXId: this.eRXId,
        instructions: this.instructions,
        quantity: this.quantity,
        refills: this.refills,

        providerFirstName: this.providerFirstName,
        providerLastName: this.providerLastName,
        providerNPI: this.providerNPI,

        writtenAt: this.writtenAt,
        expirationDate: this.expirationDate
    });
}

export default PrescriptionAddOnDetails;
